import { CurrentTheme, Theme } from '@app/core/featureToggle';
import { IconTypes } from '@components/card/CardFilterBar';
import { BDSMainColor } from '@constants/bds.constants';
import { Theme as MFETheme, Tenant } from '@ftdr/product-comparison-cards-micro-frontend';

interface IThemeConfig {
  faviconRelPath: string;
  buttonThemeShape?: string;
  defaultNavMenuLinkColor: string;
  defaultNavMenuButtonColor: string;
  defaultNavMenuButtonShape: string;
  seePricesButtonColor: string;
  userMenuColor: string;
  modalStyleClass: string;
  modalStyleButton: string;
  modelCancelButtonVariant: string;
  dashboardCardMarginBottom: string;
  dashboardCardRounded: string;
  dashboardCardQuickLinksContainer: string;
  contentBoxContainer: string;
  contentBoxSubtitleClass: string;
  contextBoxTitleClass: string;
  dashboardCardButtonColor: string;
  dashboardCardBadgeColor: string;
  dashboardQLCardBadgeColor: string;
  dashboardWNCardBadgeColor: string;
  modalOkStyleButtonColor: string;
  modalFilterOfficesTextColor: string;
  faqPanelClass?: string;
  faqPanelRoundedSize?: string;
  faqPanelShadow?: string;
  faqStickyMenuClass?: string;
  faqStickyMenuButton?: string;
  faqCategoriesContainerClass?: string;
  faqStillHaveQuestionsVariant?: string;
  faqStillHaveQuestionsClass?: string;
  faqSubmitRequestClass?: string;
  faqRequestSupportButtonClass?: string;
  faqButtonColor?: string;
  drawerDocAddressStyles?: string;
  drawerDocFontSize?: string;
  drawerDocFontWeight?: string;
  drawerDocDownloadButtonColor?: string;
  badgeActiveColor: string;
  tableAltRowVariant: string;
  tableTextWeight?: string;
  contactUsHeaderClass?: string;
  contactUsSuccessClass?: string;
  contactUsSuccessTextClass?: string;
  contactUsPanelRounded: string;
  contactUsPanelShadow?: boolean;
  contactUsPanelBorder?: string;
  contactUsFormClass?: string;
  contactUsFormFaqClass: string;
  contactUsFormFaqUrlClass?: string;
  contactUsThemeTextColor: string;
  contactUsUploadTitleClass?: string;
  contactUsUploadClass: string;
  contactUsSuccessPanelRounded?: string;
  contactUsSuccessPanelShadow?: boolean;
  contactUsSuccessButtonWidth?: string;
  contactUsSuccessButtonClassName?: string;
  contactUsSuccessButtonDivClassName?: string;
  contactUsSubmitButtonColor?: string;
  contactUsSubmitButtonShape?: string;
  accountButtonShape: string;
  accountButtonVariant: string;
  accountPanelClass: string;
  accountPanelRounded: string;
  accountPanelShadow: boolean;
  accountInformationLabelMargin: string;
  accountInformationContainerClass: string;
  accountInformationContainerWidth: string;
  accountContactInfoButtonContainer: string;
  accountContactInfoButtonWidth: string;
  accountContactInfoButtonClass: string;
  accountButtonColor: string;
  accountSubtitleVariant: string;
  accountContactInfoInputContainer: object;
  accountContactInfoLinkWeight: string;
  accountEditLinkClass?: string;
  accountContactInfoSaveButtonContainer: string;
  accountContactInfoCaptchaContainer: string;
  accountContactInfoNarContainer: string;
  accountContactInfoNarContaineWidth: object;
  accountContactInfoInputsContainerWidth: string;
  accountContactInfoInputsContainerClass: string;
  accountOfficeInfoContainer: string;
  accountOfficeInfoContent: string;
  accountOfficeInfoButtonWidth: string;
  accountOfficeInfoButtonContainer: string;
  accountOfficeInfoMTBetweenContent: string;
  accountOfficeInfoMBBetweenContent: string;
  accountOfficeInfoPanelClass: string;
  accountOfficeTitleContainer: string;
  accountOfficeTitleMargin: string;
  cardOrderText: string;
  cardOrderErrorStatusColor: string;
  btnPillShapedPrimary?: string;
  displayNewOrdersPlanMFE?: boolean;
  salesMaterialPanelClass: string;
  salesMaterialDisplayREProfessionals: boolean;
  salesMaterialGridClass: string;
  salesMaterialCardContainerClass: string;
  salesMaterialCardClass: string;
  salesMaterialCardShadow: boolean;
  salesMaterialCardRounded: string;
  salesMaterialCardMargin: string;
  salesMaterialCardTitleClass: string;
  salesMaterialCardCollapsibleTextClass: string;
  salesMaterialCardLinkUnderlineClass: string;
  salesMaterialCardLinkTextExpanded: string;
  salesMaterialCardLinkTextNotExpanded: string;
  salesMaterialCardSelectClass: string;
  salesMaterialCardButtonsContainer: string;
  salesMaterialCardSharePopoverClass: string;
  salesMaterialCardShareButtonClass: string;
  salesMaterialCardShareButtonColor: string;
  salesMaterialCardDownloadPopoverClass: string;
  salesMaterialCardDownloadButtonClass: string;
  salesMaterialCardDownloadButtonColor: string;
  salesMaterialCardDownloadButtonIcon: boolean;
  salesMaterialCardButtonShape: string;
  drawerOrderContainerPadding: string;
  drawerOrderContainerBorder: boolean;
  drawerOrderCardPadding: string;
  drawerOrderCardBorder: string;
  sendDocumentsTrashIconColor: string;
  sendDocumentsCheckboxContainer: string;
  sendDocumentsHeaderConfirm: string;
  sendDocumentsHeaderInvoice: string;
  sendDocumentsHeaderRecipients: string;
  sendDocumentsHeaderName: string;
  sendDocumentsEmail: string;
  sendDocumentsLabelContainer: string;
  sendDocumentsLabel: string;
  sendDocumentsLabelVariant: string;
  sendDocumentsAddress: string;
  sendDocumentsAddressVariant: string;
  sendDocumentsTableVariant: string;
  sendDocumentsContainerButton: string;
  sendDocumentsButtonShape?: string;
  sendDocumentsAddRecButtonColor?: string;
  sendDocumentsSaveButtonColor?: string;
  sendRenewalItemMT: 'string';
  sendRenewalHeaderWidth: string;
  sendRenewalCheckboxClass: string;
  sendRenewalCheckboxWidth: string;
  sendRenewalTableVariant: string;
  sendRenewalTableHeaderColor: string;
  sendRenewalAddButtonWidth: string;
  sendRenewalAddButtonColor: string;
  sendRenewalTrashIconColor: string;
  sendRenewalSendButtonColor: string;
  sendDocsNewOrderPanelPadding: string;
  sendDocsNewOrderPanelRounded: string;
  sendDocsNewOrderPanelBorderT: string;
  sendDocsNewOrderPanelShadow: boolean;
  addOfficeButtonShape: string;
  addOfficeSearchButtonColor: string;
  addOfficeChooseOfficeButtonColor?: string;
  officeSearchResultTitleColor: string;
  cantFindOfficeIconColor?: string;
  officesContainerClass?: string;
  officesSearchIcon?: string;
  officesResultNumberClass?: string;
  officesResultsContainer?: string;
  cardOfficePanelRounded?: string;
  cardOfficePanelBorderT?: string;
  cardOfficePanelShadow?: boolean;
  cardOfficeNameVariant?: string;
  cardOfficeLabelVariant?: string;
  cardOfficeLabelClass?: string;
  cardOfficeAddressContainerClass?: string;
  cardOfficeContainerLabelClass?: string;
  cardOfficeWarrantyContainerClass?: string;
  cardOfficeWarrantyVariant?: string;
  drawerWLKInviteOfficeNameClass?: string;
  drawerWLKInviteOfficeButtonShape?: string;
  drawerWLKInviteOfficeButtonColor?: string;
  drawerWLKInviteOfficeButtonVariant?: string;
  lineItemLabelVariant?: string;
  lineItemCaptionVariant?: string;
  noOfficesFoundShadow?: boolean;
  noOfficesFoundRounded?: string;
  noOfficesFoundPadding?: string;
  newOrderPanelBorder?: string;
  newOrderPanelShadow?: boolean;
  newOrderPanelRounded?: string;
  newOrderBuyerPanelBackground?: string;
  newOrderBuyerPanelRounded?: string;
  newOrderBuyerBannerTextColor?: string;
  newOrderClosingInfoBackground?: string;
  newOrderClosingInfoRounded?: string;
  newOrderClosingInfoShadow?: boolean;
  formOfficeSearchResults: string;
  formOfficeButtonsContainer: string;
  formOfficeCancelButtonClass: string;
  formOfficeSearchButtonClass: string;
  formOfficeResultsContainer: string;
  formOfficeResultsPlaceholder: string;
  formOfficeSearchIconColor: string;
  formOfficeSearchRadioContainer: string;
  formOfficeSearchFieldsContainer: string;
  newOrderBannerBackground?: string;
  newOrderBannerRounded?: string;
  newOrderBannerShadow?: boolean;
  newOrderSendDocumentsRounded?: string;
  newOrderSendDocumentsBorderT?: string;
  newOrderSendDocumentsShadow?: boolean;
  newOrderSubmitButtonVariant?: string;
  newOrderSubmitButtonColor?: string;
  newOrderSubmitButtonShape?: string;
  newOrderSaveButtonColor?: string;
  OfficeAutoCompleteButtonColor?: string;
  autosuggestButtonColor?: string;
  orderSubmittedPanelClass?: string;
  orderSubmittedPanelShadow?: boolean;
  orderSubmittedPanelBorder?: string;
  orderSubmittedPanelPadding?: string;
  orderSubmittedContentClass?: string;
  agentVerificationButtonColor?: string;
  agentVerificationLinkColor?: string;
  agentVerificationLinkTextDecoration?: string;
  agentVerificationLinkFontWeight?: string;
  coveredAddressEditButtonColor?: string;
  coveredAddressUseButtonColor?: string;
  cardPlanPanelRounded?: string;
  cardPlanPanelShadow?: boolean;
  cardPlanPanelBorder?: string;
  cardPlanButtonClassName?: string;
  inelegibleDwellingSizeUpdateButtonColor?: string;
  incompleteOrderFoundModalButtonShape?: string;
  missingBuyerPhoneButtonColor?: string;
  myQuotesBannerBackgroundColor?: string;
  myQuotesBannerRounded?: string;
  myQuotesBannerShadow?: boolean;
  myQuotesSearchBarIcon?: string;
  myQuotesIdFontWeight?: string;
  myQuotesFilterButtonShape?: string;
  myQuotesSearchBarContainerClass?: string;
  myQuotesTableContainerClass?: string;
  viewQuoteLeftContainerClass?: string;
  viewQuoteRightContainerClass?: string;
  viewQuoteButtonShape?: string;
  viewQuoteShareButtonColor: string;
  viewQuoteConvertButtonColor: string;
  viewQuoteViewButtonColor?: string;
  quoteSummaryLabelVariant?: string;
  quoteSummaryValueVariant?: string;
  quoteSummaryLineItemMarginBottom?: string;
  quoteSummaryLineItemMarginTop?: string;
  quoteSummaryCardClass?: string;
  quoteSummaryContainerDisablePadding?: boolean;
  quoteSummaryContainerMargin?: string;
  quoteSummaryPlansPricesClass?: string;
  quoteSummaryLineItemContainerClass?: string;
  quoteSummaryHeaderClass: string;
  quoteSummaryResidenceClass: string;
  quoteSummaryDisplayBreakLine: string;
  quoteSummaryPlanNameVariant: string;
  quoteSummaryDisplaySeparator: boolean;
  shareQuoteButtonColor?: string;
  shareQuoteButtonShape?: string;
  cancelQuoteReasonLabelClass: string;
  cancelQuoteReasonSelectClass: string;
  cancelQuoteOtherReasonClass: string;
  cancelQuoteButtonsContainerClass: string;
  cancelQuoteButtonClass: string;
  cancelQuoteCancelButtonColor: string;
  filterQuotesButtonShape?: string;
  filterQuotesButtonColor?: string;
  newOrderCoverageTableHeaderClass?: string;
  newOrderPlansContainerLoader?: string;
  wlkAccordianItemPanelClass: string;
  wlkAccordianItemShadow: boolean;
  wlkPanelRounded: string;
  wlkPanelMobileDisplay: string;
  isWlkPropertyAttributesInLowerCase: boolean;
  wlkStickyContainerClass: string;
  wlkButtonClass: string;
  wlkMobileSubmissionTextClass: string;
  wlkVerificationSubmitButtonColor: string;
  wlkAgreementAcceptButtonColor?: string;
  wlkAgreementDeclineButtonColor?: string;
  hasWlkAttributeBottomMargin: boolean;
  isWlkDisplayFlex: boolean;
  plansPricesBaseCoverageContainer: string;
  plansPricesBaseCoverageRounded: string;
  plansPricesBaseCoverageBorderT: string;
  plansPricesCoverageRounded: string;
  plansPricesCoverageBorderT: string;
  quoteSummaryButtonColor?: string;
  addOnsBackgroundColor?: string;
  plansPricesMFETenant?: Tenant;
  plansPricesMFETheme?: MFETheme;
  plansPricesMFEBackgroundColor?: string;
  plansPricesContentBoxWidth?: boolean;
  drawerOrderButtonColor: string;
  drawerOrderShowDocDivider?: boolean;
  drawerOrderDocumentClass?: string;
  drawerOrderDocumentIconColor: string;
  drawerOrderDocumentsClass: string;
  drawerOrderDocumentSendButtonVariant: string;
  drawerOrderDocumentSendButtonColor: string;
  drawerOrderEditHistoryTableClass: string;
  drawerOrderEditHistoryTableIconColor: string;
  chatEnabled: boolean;
  registrationButtonContainerClass?: string;
  registrationCancelButtonClass?: string;
  registrationButtonColor?: string;
  existingUserContinueButtonColor?: string;
  existingUserNoneButtonColor?: string;
  promoCodeValidateButtonColor?: string;
}

const THEME_CONFIG = new Map<Theme, IThemeConfig>();

// If we end up with a bunch of configuration items that can be combined and spread into props, then adjust the interface and refactor.
//TODO Separate out brand concerns into BRAND_CONFIG. The BRAND_CONFIG can point to the theme it's using.

THEME_CONFIG[Theme.Ahs2024] = {
  faviconRelPath: '/ahs-favicon.ico',
  buttonThemeShape: 'pill',
  defaultNavMenuLinkColor: 'interactive',
  defaultNavMenuButtonColor: 'interactive',
  defaultNavMenuButtonShape: 'pill',
  seePricesButtonColor: 'interactive',
  userMenuColor: 'interactive',
  modalStyleClass: '',
  modalStyleButton: 'button-pill',
  modalCancelButtonVariant: 'ghost',
  modalOkStyleButtonColor: BDSMainColor.Interactive,
  dashboardCardMarginBottom: 'mb-4',
  dashboardCardRounded: 'xl',
  dashboardCardQuickLinksContainer: 'h-full flex flex-col justify-center ',
  contentBoxContainer: 'mx-4 xs:mx-4 sm:mx-4 md:mx-4 lg:mx-4 ',
  contentBoxSubtitleClass: '',
  contextBoxTitleClass: 'ml-0',
  dashboardCardButtonColor: 'interactive',
  dashboardCardBadgeColor: BDSMainColor.Primary,
  dashboardQLCardBadgeColor: BDSMainColor.Primary,
  dashboardWNCardBadgeColor: BDSMainColor.Primary,
  modalFilterOfficesTextColor: BDSMainColor.Primary,
  faqPanelClass: 'flex flex-col md:flex-row p-4 md:p-6',
  faqPanelRoundedSize: 'xl',
  faqPanelShadow: false,
  faqStickyMenuClass: 'w-full md:w-48 mr-12',
  faqStickyMenuButton: 'px-0 py-6 max-w-48 md:w-full',
  faqCategoriesContainerClass: 'max-w-4xl',
  faqStillHaveQuestionsVariant: 'heading-06',
  faqStillHaveQuestionsClass: 'pt-8 md:pt-2 normal-case',
  faqSubmitRequestClass: 'pt-4 md:pt-0',
  faqRequestSupportButtonClass: 'mt-6',
  faqButtonColor: BDSMainColor.Interactive,
  drawerDocAddressStyles: 'sm:text-lg text-primary-400',
  drawerDocFontSize: '',
  drawerDocFontWeight: 'font-normal',
  drawerDocDownloadButtonColor: BDSMainColor.Interactive,
  badgeActiveColor: BDSMainColor.Secondary,
  tableAltRowVariant: 'heavy',
  tableTextWeight: 'font-bold',
  contactUsSuccessClass: 'recontainer py-10',
  contactUsSuccessTextClass: 'text-left mx-0 lg:text-center lg:m-auto',
  contactUsPanelRounded: 'xl',
  contactUsFormClass: 'w-fit text-left py-4 lg:text-center p-4 lg:m-auto',
  contactUsFormFaqClass: 'text-primary inline pb-4',
  contactUsThemeTextColor: 'text-primary-400',
  contactUsUploadTitleClass: 'text-primary',
  contactUsUploadClass: 'w-full text-center media-upload-format text-primary',
  contactUsSuccessPanelRounded: 'xl',
  contactUsSuccessButtonDivClassName: 'media-upload-format py-6 lg:m-auto button-pill',
  contactUsSuccessButtonWidth: 'full',
  contactUsSuccessButtonClassName: 'button-pill',
  accountButtonShape: 'pill',
  accountButtonVariant: 'outlined',
  accountButtonColor: BDSMainColor.Interactive,
  accountSubtitleVariant: 'heading-05',
  accountPanelClass: 'p-4 md:p-6 mt-6',
  accountPanelRounded: 'xl',
  accountPanelShadow: false,
  accountInformationLabelMargin: 'mb-6',
  accountInformationContainerClass: 'flex flex-col',
  accountInformationContainerWidth: 'flex flex-col flex-1',
  accountContactInfoButtonContainer: 'flex w-fit self-start ml-1 md:min-w-32',
  accountContactInfoButtonWidth: 'full',
  accountContactInfoButtonClass: 'mt-5',
  accountContactInfoInputContainer: { maxWidth: '680px' },
  accountContactInfoLinkWeight: 'font-bold',
  accountEditLinkClass: 'font-bold pl-4',
  accountContactInfoSaveButtonContainer: 'md:mt-6 md:min-w-32',
  accountContactInfoCaptchaContainer: '',
  accountContactInfoNarContainer: '',
  accountContactInfoNarContaineWidth: { maxWidth: '500px' },
  accountContactInfoInputsContainerWidth: 'w-full',
  accountContactInfoInputsContainerClass: '',
  accountOfficeInfoContainer: 'flex-col md:flex-row',
  accountOfficeInfoContent: 'pl-9',
  accountOfficeInfoButtonWidth: 'full',
  accountOfficeInfoButtonContainer: 'md:min-w-32',
  accountOfficeInfoMTBetweenContent: 'mt-4',
  accountOfficeInfoMBBetweenContent: 'mb-4',
  accountOfficeInfoPanelClass: 'p-4 md:p-6 mt-6',
  accountOfficeTitleContainer: 'mb-4 md:mb-6 flex-col md:flex-row',
  accountOfficeTitleMargin: 'mb-2',
  cardOrderText: 'text-primary-400 group-hover:text-primary-300 ',
  cardOrderErrorStatusColor: 'text-secondary',
  displayNewOrdersPlanMFE: true,
  salesMaterialPanelClass: 'my-6',
  salesMaterialDisplayREProfessionals: false,
  salesMaterialGridClass: 'grid gap-6 md:grid-cols-2 lg:grid-cols-3',
  salesMaterialCardContainerClass: '',
  salesMaterialCardClass: 'h-full flex flex-col shadow-rebrand',
  salesMaterialCardShadow: false,
  salesMaterialCardRounded: 'xl',
  salesMaterialCardMargin: 'mt-6 mx-6',
  salesMaterialCardTitleClass: 'mb-1',
  salesMaterialCardCollapsibleTextClass: '',
  salesMaterialCardLinkUnderlineClass: 'never',
  salesMaterialCardLinkTextExpanded: 'Less',
  salesMaterialCardLinkTextNotExpanded: 'Read more',
  salesMaterialCardSelectClass: 'py-6',
  salesMaterialCardButtonsContainer: 'flex px-6 pb-6 flex-1 flex-col-reverse md:flex-row',
  salesMaterialCardPopoverClass: 'content-end mr-3 w-full',
  salesMaterialCardShareButtonClass: 'mx-0',
  salesMaterialCardShareButtonColor: 'interactive',
  salesMaterialCardDownloadButtonClass: 'mx-0 mb-5 md:mb-0',
  salesMaterialCardDownloadButtonColor: 'interactive',
  salesMaterialCardDownloadButtonIcon: false,
  salesMaterialCardButtonShape: 'pill',
  drawerOrderContainerPadding: '',
  drawerOrderContainerBorder: false,
  drawerOrderCardPadding: 'pr-4',
  drawerOrderCardBorder: ' bg-white rounded-tr-5 rounded-br-5 rounded-bl-5 rounded-tl-5',
  sendDocumentsTrashIconColor: 'interactive',
  sendDocumentsCheckboxContainer: 'flex pl-4 self-center checkbox',
  sendDocumentsHeaderConfirm: 'px-0 md:px-4 text-left',
  sendDocumentsHeaderInvoice: 'px-0 md:px-8 text-left',
  sendDocumentsHeaderRecipients: 'pr-0 md:pr-8',
  sendDocumentsHeaderName: 'pr-0 md:pr-8 w-20 md:w-full',
  sendDocumentsEmail: 'w-20 md:w-full',
  sendDocumentsLabelContainer: 'p-0 w-full',
  sendDocumentsLabel: 'pb-6',
  sendDocumentsLabelVariant: 'heading-05',
  sendDocumentsAddress: 'pb-6',
  sendDocumentsAddressVariant: 'heading-06',
  sendDocumentsTableVariant: 'heavy',
  sendDocumentsContainerButton: 'pt-6',
  sendDocumentsButtonShape: 'pill',
  sendDocumentsAddRecButtonColor: 'interactive',
  sendDocumentsSaveButtonColor: 'interactive',
  sendRenewalItemMT: 'mt-4',
  sendRenewalHeaderWidth: 'w-20 md:w-full',
  sendRenewalCheckboxClass: 'flex pl-4 self-center checkbox',
  sendRenewalCheckboxWidth: 'full',
  sendRenewalTableVariant: 'heavy',
  sendRenewalTableHeaderColor: 'interactive',
  sendRenewalAddButtonWidth: 'full',
  sendRenewalAddButtonColor: 'interactive',
  sendRenewalTrashIconColor: 'interactive',
  sendRenewalSendButtonColor: 'interactive',
  sendDocsNewOrderPanelPadding: 'xl',
  sendDocsNewOrderPanelRounded: 'xl',
  sendDocsNewOrderPanelBorderT: '0',
  sendDocsNewOrderPanelShadow: false,
  addOfficeButtonShape: 'rounded',
  addOfficeSearchButtonColor: 'interactive',
  officeSearchResultTitleColor: 'primary',
  cantFindOfficeIconColor: 'interactive',
  officesContainerClass: '',
  officesSearchIcon: IconTypes.Search,
  officesResultNumberClass: 'mt-6',
  officesResultsContainer: 'mt-4',
  cardOfficePanelRounded: 'xl',
  cardOfficePanelBorderT: '0',
  cardOfficePanelShadow: false,
  cardOfficeNameVariant: 'label',
  cardOfficeLabelVariant: 'caption',
  cardOfficeLabelClass: 'mb-3',
  cardOfficeAddressContainerClass: '',
  cardOfficeContainerLabelClass: 'mb-3',
  cardOfficeWarrantyContainerClass: '',
  cardOfficeWarrantyVariant: 'label',
  drawerWLKInviteOfficeNameClass: 'mt-4',
  drawerWLKInviteOfficeButtonShape: 'rounded',
  drawerWLKInviteOfficeButtonColor: 'interactive',
  drawerWLKInviteOfficeButtonVariant: 'filled',
  lineItemLabelVariant: 'label',
  lineItemCaptionVariant: 'caption',
  noOfficesFoundShadow: true,
  noOfficesFoundRounded: 'md',
  noOfficesFoundBorder: '2',
  newOrderPanelBorder: undefined,
  newOrderPanelShadow: false,
  newOrderPanelRounded: 'xl',
  newOrderBuyerPanelBackground: 'accent-500',
  newOrderBuyerPanelRounded: 'xl',
  newOrderBuyerBannerTextColor: 'secondary',
  newOrderClosingInfoBackground: 'accent-500',
  newOrderClosingInfoRounded: 'xl',
  newOrderClosingInfoShadow: false,
  formOfficeSearchResults: 'font-bold mb-2',
  formOfficeButtonsContainer: 'mt-5',
  formOfficeCancelButtonClass: 'sm-max:w-full',
  formOfficeSearchButtonClass: 'sm-max:w-full',
  formOfficeResultsContainer: 'mt-5',
  formOfficeResultsPlaceholder:
    'Search this area by company name, address, phone, or Distributor ID...',
  formOfficeSearchIconColor: 'primary',
  formOfficeSearchRadioContainer: 'mt-5',
  formOfficeSearchFieldsContainer: 'mt-2',
  newOrderBannerBackground: 'accent-500',
  newOrderBannerRounded: 'xl',
  newOrderBannerShadow: false,
  newOrderSendDocumentsRounded: 'xl',
  newOrderSendDocumentsBorderT: '0',
  newOrderSendDocumentsShadow: false,
  newOrderSubmitButtonVariant: 'outlined',
  newOrderSubmitButtonColor: 'interactive',
  newOrderSubmitButtonShape: 'pill',
  newOrderSaveButtonColor: 'interactive',
  OfficeAutoCompleteButtonColor: 'interactive',
  autosuggestButtonColor: 'interactive',
  orderSubmittedPanelClass:
    'flex flex-col mt-6 px-4 sm:px-12 lg:px-32 py-8 sm:py-10 justify-center items-center',
  orderSubmittedPanelShadow: true,
  orderSubmittedPanelBorder: '0',
  orderSubmittedPanelPadding: 'none',
  orderSubmittedContentClass: 'px-5 md:px-20',
  agentVerificationButtonColor: 'interactive',
  agentVerificationLinkColor: '#182AF0',
  agentVerificationLinkTextDecoration: 'none',
  agentVerificationLinkFontWeight: 'normal',
  coveredAddressEditButtonColor: 'interactive',
  coveredAddressUseButtonColor: 'interactive',
  cardPlanPanelRounded: 'xl',
  cardPlanPanelShadow: false,
  cardPlanPanelBorder: '1',
  cardPlanButtonClassName: '',
  inelegibleDwellingSizeUpdateButtonColor: 'interactive',
  incompleteOrderFoundModalButtonShape: 'pill',
  missingBuyerPhoneButtonColor: 'interactive',
  myQuotesBannerBackgroundColor: 'accent-500',
  myQuotesBannerRounded: 'xl',
  myQuotesBannerShadow: false,
  myQuotesSearchBarIcon: IconTypes.Filter,
  myQuotesIdFontWeight: 'font-bold',
  myQuotesFilterButtonShape: 'pill',
  myQuotesSearchBarContainerClass: 'card',
  myQuotesTableContainerClass: 'sm-max:hidden',
  viewQuoteLeftContainerClass: 'space-y-4',
  viewQuoteRightContainerClass: 'md:pr-2 mt-4 md:mt-0 space-y-4',
  viewQuoteButtonShape: 'rounded',
  viewQuoteShareButtonColor: 'interactive',
  viewQuoteConvertButtonColor: 'interactive',
  viewQuoteViewButtonColor: 'interactive',
  quoteSummaryLabelVariant: 'heading-06',
  quoteSummaryValueVariant: 'body-short',
  quoteSummaryLineItemMarginBottom: 'mb-4',
  quoteSummaryLineItemMarginTop: 'mt-4',
  quoteSummaryCardClass: 'rounded-5 p-6',
  quoteSummaryContainerDisablePadding: true,
  quoteSummaryContainerMargin: '',
  quoteSummaryPlansPricesClass: 'align-center',
  quoteSummaryLineItemContainerClass: 'mb-2',
  quoteSummaryHeaderClass: 'mb-4',
  quoteSummaryResidenceClass: 'text-right',
  quoteSummaryDisplayBreakLine: false,
  quoteSummaryPlanNameVariant: '',
  quoteSummaryDisplaySeparator: true,
  shareQuoteButtonColor: 'interactive',
  shareQuoteButtonShape: 'pill',
  cancelQuoteReasonLabelClass: 'mt-6',
  cancelQuoteReasonSelectClass: 'mt-6',
  cancelQuoteOtherReasonClass: 'mt-6',
  cancelQuoteButtonsContainerClass: 'mt-6 flex w-full',
  cancelQuoteButtonClass: 'flex justify-end',
  cancelQuoteCancelButtonColor: 'error',
  filterQuotesButtonShape: 'pill',
  filterQuotesButtonColor: 'interactive',
  newOrderCoverageTableHeaderClass: 'pl-6',
  newOrderPlansContainerLoader: 'p-3',
  wlkAccordianItemPanelClass: 'accordion-item rounded bg-white  border-2 mb-4 ',
  wlkAccordianItemShadow: true,
  wlkPanelRounded: 'xl',
  wlkPanelMobileDisplay: 'flex-column',
  isWlkPropertyAttributesInLowerCase: true,
  wlkStickyContainerClass: ' ',
  wlkButtonClass: 'button-pill',
  wlkMobileSubmissionTextClass: 'mb-4',
  wlkVerificationSubmitButtonColor: 'interactive',
  wlkAgreementAcceptButtonColor: 'interactive',
  wlkAgreementDeclineButtonColor: 'interactive',
  hasWlkAttributeBottomMargin: true,
  isWlkDisplayFlex: true,
  plansPricesBaseCoverageContainer: 'pb-4',
  plansPricesBaseCoverageRounded: 'xl',
  plansPricesBaseCoverageBorderT: '0',
  plansPricesCoverageRounded: 'xl',
  plansPricesCoverageBorderT: '0',
  quoteSummaryButtonColor: 'interactive',
  plansPricesMFETenant: Tenant.AHS,
  plansPricesMFETheme: MFETheme.AHS2024,
  plansPricesMFEBackgroundColor: 'bg-pale-100',
  plansPricesContentBoxWidth: false,
  drawerOrderButtonColor: 'interactive',
  drawerOrderDocumentIconColor: 'interactive',
  drawerOrderDocumentsClass: 'pb-4',
  drawerOrderDocumentSendButtonVariant: 'filled',
  drawerOrderEditHistoryTableClass:
    'mt-4 p-4 bg-white rounded-tr-5 rounded-br-5 rounded-bl-5 rounded-tl-5',
  drawerOrderEditHistoryTableIconColor: 'interactive',
  drawerOrderShowDocDivider: false,
  chatEnabled: false,
  registrationButtonContainerClass: 'flex-col-reverse md:flex-row',
  registrationCancelButtonClass: 'sm-max:mt-4',
  registrationButtonColor: 'interactive',
  existingUserContinueButtonColor: 'interactive',
  existingUserNoneButtonColor: 'interactive',
  promoCodeValidateButtonColor: 'interactive',
};

THEME_CONFIG[Theme.AhsWebApp] = {
  faviconRelPath: '/hsa-favicon.ico', //TODO move to BRAND_CONFIG in the future
  buttonThemeShape: 'rounded',
  defaultNavMenuLinkColor: 'primary',
  defaultNavMenuButtonColor: 'primary',
  defaultNavMenuButtonShape: 'rounded',
  seePricesButtonColor: 'interactive',
  userMenuColor: 'interactive',
  modalStyleClass: '',
  modalStyleButton: '',
  modalOkStyleButtonColor: BDSMainColor.Interactive,
  modelCancelButtonVariant: 'outlined',
  dashboardCardMarginBottom: '',
  dashboardCardRounded: 'lg',
  dashboardCardQuickLinksContainer: 'h-full flex flex-col gap-1 pt-5 justify-center',
  contentBoxContainer: 'lg:px-6 md:px-6 px-2 min-w-80 max-w-xxl mx-auto',
  contentBoxSubtitleClass: 'auto',
  contextBoxTitleClass: '',
  dashboardCardButtonColor: 'interactive',
  dashboardCardBadgeColor: BDSMainColor.Primary,
  dashboardQLCardBadgeColor: BDSMainColor.Primary,
  dashboardWNCardBadgeColor: BDSMainColor.Interactive,
  modalFilterOfficesTextColor: BDSMainColor.Primary,
  faqPanelClass: '-m-2 flex flex-wrap noFlexWrap1024 mx-0 p-0',
  faqPanelRoundedSize: 'md',
  faqPanelShadow: true,
  faqStickyMenuClass: 'w-80',
  faqStickyMenuButton: 'py-3 pl-4 md:pl-6 pr-16 md:pr-20 w-full',
  faqCategoriesContainerClass: 'ml-5',
  faqStillHaveQuestionsVariant: 'heading-03',
  faqStillHaveQuestionsClass: 'normal-case',
  faqSubmitRequestClass: '',
  faqRequestSupportButtonClass: '',
  faqButtonColor: 'interactive',
  drawerDocAddressStyles: 'sm:text-lg text-primary-400',
  drawerDocFontWeight: 'font-normal',
  drawerDocDownloadButtonColor: BDSMainColor.Interactive,
  badgeActiveColor: BDSMainColor.Secondary,
  tableAltRowVariant: 'heavy',
  tableTextWeight: undefined,
  contactUsPaneRounded: 'md',
  contactUsPanelShadow: true,
  contactUsFormFaqClass: 'Semantics/text/Primary',
  contactUsFormFaqUrlClass:
    'no-underline text-label text-interactive line-clamp-none horizontal-main-nav-menu-item-link-label',
  contactUsThemeTextColor: 'text-primary-300',
  contactUsUploadClass: 'media-upload-format',
  contactUsUploadTitleClass: 'pt-4 pb-2',
  contactUsSuccessPanelRounded: 'md',
  contactUsSuccessPanelShadow: true,
  contactUsSuccessButtonWidth: 'auto',
  accountButtonShape: 'rounded',
  accountButtonVariant: 'filled',
  accountButtonColor: BDSMainColor.Interactive,
  accountSubtitleVariant: 'heading-05',
  accountPanelClass: 'px-8 py-10 mt-8',
  accountPanelRounded: 'md',
  accountPanelShadow: true,
  accountInformationLabelMargin: 'mb-4',
  accountInformationContainerClass: 'md:flex',
  accountInformationContainerWidth: 'md:w-3/5 md:pr-8 lg:pr-16',
  accountContactInfoButtonContainer: 'py-0 flex-none w-14',
  accountContactInfoButtonWidth: 'auto',
  accountContactInfoButtonClass: 'mt-6',
  accountContactInfoInputContainer: {},
  accountContactInfoLinkWeight: '',
  accountEditLinkClass: '',
  accountContactInfoSaveButtonContainer: 'mt-6 md:mt-auto',
  accountContactInfoCaptchaContainer: 'md:w-2/5',
  accountContactInfoNarContainer: 'lg:w-1/2 lg:pr-4',
  accountContactInfoNarContaineWidth: {},
  accountContactInfoInputsContainerWidth: 'w-full sm:w-3/4 ml-4',
  accountContactInfoInputsContainerClass: '-mx-4',
  accountOfficeInfoContainer: '',
  accountOfficeInfoContent: '',
  accountOfficeInfoButtonWidth: 'auto',
  accountOfficeInfoButtonContainer: '',
  accountOfficeInfoSpaceBetweenContent: '',
  accountOfficeInfoMTBetweenContent: '',
  accountOfficeInfoMBBetweenContent: '',
  accountOfficeInfoPanelClass:
    'card--office-info xs-max:overflow-visible sm:px-8 sm:py-5 mt-8 xs-max:bg-transparent xs-max:shadow-none',
  accountOfficeTitleContainer: 'mb-4 items-center',
  accountOfficeTitleMargin: '',
  cardOrderText: 'text-primary-400 group-hover:text-primary-300 ',
  cardOrderErrorStatusColor: 'text-red-400',
  displayNewOrdersPlanMFE: false,
  salesMaterialPanelClass: 'card my-4 py-4',
  salesMaterialDisplayREProfessionals: true,
  salesMaterialGridClass: 'md:flex flex-wrap',
  salesMaterialCardContainerClass: 'p-3 md:w-1/2 lg:w-1/3',
  salesMaterialCardClass: 'h-auto',
  salesMaterialCardShadow: true,
  salesMaterialCardRounded: 'md',
  salesMaterialCardMargin: 'mt-3',
  salesMaterialCardTitleClass: 'ml-3 mb-1',
  salesMaterialCardCollapsibleTextClass: 'ml-3 mb-1',
  salesMaterialCardLinkUnderlineClass: 'always',
  salesMaterialCardLinkTextExpanded: 'less',
  salesMaterialCardLinkTextNotExpanded: 'read more',
  salesMaterialCardSelectClass: 'm-3',
  salesMaterialCardButtonsContainer: 'flex items-center justify-evenly px-1 mt-4 mb-3',
  salesMaterialCardPopoverClass: 'mr-3 w-full',
  salesMaterialCardShareButtonClass: 'm-2',
  salesMaterialCardShareButtonColor: 'interactive',
  salesMaterialCardDownloadButtonClass: 'm-2',
  salesMaterialCardDownloadButtonColor: 'interactive',
  salesMaterialCardDownloadButtonIcon: true,
  salesMaterialCardButtonShape: 'rounded',
  drawerOrderContainerPadding: 'py-2',
  drawerOrderContainerBorder: true,
  drawerOrderCardPadding: 'px-4',
  drawerOrderCardBorder: 'card',
  sendDocumentsTrashIconColor: 'primary',
  sendDocumentsCheckboxContainer: 'lg:text-center',
  sendDocumentsHeaderConfirm: '',
  sendDocumentsHeaderInvoice: '',
  sendDocumentsHeaderRecipients: '',
  sendDocumentsHeaderName: '',
  sendDocumentsEmail: '',
  sendDocumentsLabelContainer: 'w-full',
  sendDocumentsLabel: 'pt-2',
  sendDocumentsLabelVariant: 'heading-05',
  sendDocumentsAddress: '',
  sendDocumentsAddressVariant: 'heading-06',
  sendDocumentsTableVariant: 'light',
  sendDocumentsContainerButton: 'py-4',
  sendDocumentsButtonShape: 'rounded',
  sendDocumentsAddRecButtonColor: 'interactive',
  sendDocumentsSaveButtonColor: 'interactive',
  sendRenewalItemMT: '',
  sendRenewalHeaderWidth: '',
  sendRenewalCheckboxClass: 'lg:text-center',
  sendRenewalCheckboxWidth: undefined,
  sendRenewalTableVariant: 'light',
  sendRenewalTableHeaderColor: 'primary',
  sendRenewalAddButtonWidth: undefined,
  sendRenewalAddButtonColor: 'interactive',
  sendRenewalTrashIconColor: 'primary',
  sendRenewalSendButtonColor: 'interactive',
  sendDocsNewOrderPanelPadding: 'xl',
  sendDocsNewOrderPanelRounded: 'md',
  sendDocsNewOrderPanelBorderT: '2',
  sendDocsNewOrderPanelShadow: true,
  addOfficeButtonShape: 'rounded',
  addOfficeSearchButtonColor: 'interactive',
  officeSearchResultTitleColor: 'primary',
  officesContainerClass: 'container',
  officesSearchIcon: undefined,
  officesResultNumberClass: 'mt-4',
  officesResultsContainer: '',
  cardOfficePanelRounded: 'none',
  cardOfficePanelBorderT: '2',
  cardOfficePanelShadow: true,
  cardOfficeNameVariant: 'heading-06',
  cardOfficeLabelVariant: 'body-short',
  cardOfficeLabelClass: '',
  cardOfficeAddressContainerClass: 'md:mb-1',
  cardOfficeContainerLabelClass: 'mb-1',
  cardOfficeWarrantyContainerClass: 'md:mb-1 leading-tight',
  cardOfficeWarrantyVariant: 'heading-06',
  drawerWLKInviteOfficeNameClass: 'mt-2',
  drawerWLKInviteOfficeButtonShape: 'rounded',
  drawerWLKInviteOfficeButtonColor: 'interactive',
  drawerWLKInviteOfficeButtonVariant: 'filled',
  lineItemLabelVariant: 'body-short',
  lineItemCaptionVariant: 'body-short',
  noOfficesFoundShadow: true,
  noOfficesFoundRounded: 'md',
  noOfficesFoundBorder: '2',
  newOrderPanelBorder: '2',
  newOrderPanelShadow: true,
  newOrderPanelRounded: undefined,
  newOrderBuyerPanelBackground: 'interactive-50',
  newOrderBuyerPanelRounded: 'md',
  newOrderBuyerBannerTextColor: 'secondary',
  newOrderClosingInfoBackground: 'interactive-50',
  newOrderClosingInfoRounded: 'md',
  newOrderClosingInfoShadow: true,
  formOfficeSearchResults: undefined,
  formOfficeButtonsContainer: ' -mx-2',
  formOfficeCancelButtonClass: 'sm-max:pt-4',
  formOfficeSearchButtonClass: 'sm-max:pt-4',
  formOfficeResultsContainer: 'mt-8',
  formOfficeResultsPlaceholder:
    'Search this area by Company Name, Address, Phone or Distributor ID',
  formOfficeSearchIconColor: undefined,
  formOfficeSearchRadioContainer: 'sm-max:-mt-2 md:mb-1',
  formOfficeSearchFieldsContainer: 'mt-4',
  newOrderBannerBackground: 'interactive-50',
  newOrderBannerRounded: 'md',
  newOrderBannerShadow: true,
  newOrderSendDocumentsRounded: 'md',
  newOrderSendDocumentsBorderT: '2',
  newOrderSendDocumentsShadow: true,
  newOrderSubmitButtonVariant: undefined,
  newOrderSubmitButtonColor: 'interactive',
  newOrderSubmitButtonShape: 'rounded',
  newOrderSaveButtonColor: 'interactive',
  OfficeAutoCompleteButtonColor: 'interactive',
  autosuggestButtonColor: 'interactive',
  agentVerificationButtonColor: 'interactive',
  agentVerificationLinkColor: '#182AF0',
  agentVerificationLinkTextDecoration: 'none',
  agentVerificationLinkFontWeight: 'normal',
  coveredAddressEditButtonColor: 'interactive',
  coveredAddressUseButtonColor: 'interactive',
  cardPlanPanelRounded: 'md',
  cardPlanPanelShadow: true,
  cardPlanPanelBorder: '0',
  cardPlanButtonClassName: 'flex flex-col overflow-hidden relative h-full cursor-pointer',
  inelegibleDwellingSizeUpdateButtonColor: 'interactive',
  incompleteOrderFoundModalButtonShape: 'rounded',
  missingBuyerPhoneButtonColor: 'interactive',
  myQuotesBannerBackgroundColor: 'interactive-50',
  myQuotesBannerRounded: 'md',
  myQuotesBannerShadow: true,
  myQuotesSearchBarIcon: IconTypes.Filter,
  myQuotesIdFontWeight: undefined,
  myQuotesFilterButtonShape: 'rounded',
  myQuotesSearchBarContainerClass: '',
  myQuotesTableContainerClass: 'card sm-max:hidden',
  viewQuoteLeftContainerClass: 'space-y-2',
  viewQuoteRightContainerClass: 'space-y-2',
  viewQuoteButtonShape: 'rounded',
  viewQuoteShareButtonColor: 'interactive',
  viewQuoteConvertButtonColor: 'interactive',
  viewQuoteViewButtonColor: 'interactive',
  quoteSummaryLabelVariant: 'label',
  quoteSummaryValueVariant: 'caption',
  quoteSummaryLineItemMarginBottom: '',
  quoteSummaryLineItemMarginTop: '',
  quoteSummaryCardClass: 'border border-gray-300 rounded-3 shadow-1 py-5',
  quoteSummaryContainerDisablePadding: false,
  quoteSummaryContainerMargin: 'mx-4',
  quoteSummaryPlansPricesClass: '',
  quoteSummaryLineItemContainerClass: '',
  quoteSummaryHeaderClass: 'mt-0 mb-2',
  quoteSummaryResidenceClass: '',
  quoteSummaryDisplayBreakLine: true,
  quoteSummaryPlanNameVariant: 'label',
  quoteSummaryDisplaySeparator: false,
  shareQuoteButtonColor: 'interactive',
  shareQuoteButtonShape: 'rounded',
  cancelQuoteReasonLabelClass: 'mt-8',
  cancelQuoteReasonSelectClass: ' sm:max-w-1/2 mt-8',
  cancelQuoteOtherReasonClass: 'mt-8 sm:max-w-1/2',
  cancelQuoteButtonsContainerClass: 'mt-12 -mx-4 md:-mx-8',
  cancelQuoteButtonClass: 'px-4 md:px-8 md:flex md:justify-end',
  cancelQuoteCancelButtonColor: 'error',
  filterQuotesButtonShape: 'rounded',
  filterQuotesButtonColor: 'interactive',
  newOrderCoverageTableHeaderClass: '',
  newOrderPlansContainerLoader: '',
  wlkAccordianItemPanelClass: 'accordion-item rounded bg-white  border-2 mb-4 shadow-1',
  wlkAccordianItemShadow: false,
  wlkPanelRounded: 'sm',
  wlkPanelMobileDisplay: 'sm:flex lg:flex flex-column sm:flex-row sm-max:flex-col',
  isWlkPropertyAttributesInLowerCase: false,
  wlkStickyContainerClass:
    'extended-border-invisible border-bottom-faded sticky-container-top-index-3',
  wlkButtonClass: '',
  wlkMobileSubmissionTextClass: '',
  wlkVerificationSubmitButtonColor: 'interactive',
  wlkAgreementAcceptButtonColor: 'interactive',
  wlkAgreementDeclineButtonColor: 'interactive',
  hasWlkAttributeBottomMargin: false,
  isWlkDisplayFlex: false,
  plansPricesBaseCoverageContainer: 'pb-8',
  plansPricesBaseCoverageRounded: 'none',
  plansPricesBaseCoverageBorderT: '2',
  plansPricesCoverageRounded: 'none',
  plansPricesCoverageBorderT: '2',
  quoteSummaryButtonColor: 'interactive',
  plansPricesMFETenant: Tenant.AHS,
  plansPricesMFETheme: MFETheme.AHS2024,
  plansPricesMFEBackgroundColor: 'bg-pale-100',
  plansPricesContentBoxWidth: true,
  drawerOrderButtonColor: 'interactive',
  drawerOrderShowDocDivider: true,
  drawerOrderDocumentClass: 'py-2',
  drawerOrderDocumentIconColor: 'gray',
  drawerOrderDocumentSendButtonVariant: 'outlined',
  drawerOrderEditHistoryTableClass: 'card mt-8 p-4',
  drawerOrderEditHistoryTableIconColor: 'gray',
  chatEnabled: false,
  registrationButtonContainerClass: '',
  registrationCancelButtonClass: '',
  registrationButtonColor: 'interactive',
  existingUserContinueButtonColor: 'interactive',
  existingUserNoneButtonColor: 'interactive',
  promoCodeValidateButtonColor: 'interactive',
};

THEME_CONFIG[Theme.HBW210] = {
  faviconRelPath: '/210-favicon.ico',
  buttonThemeShape: 'pill',
  defaultNavMenuLinkColor: 'interactive',
  defaultNavMenuButtonColor: 'primary',
  defaultNavMenuButtonShape: 'pill',
  seePricesButtonColor: 'black',
  userMenuColor: 'primary',
  modalStyleClass: 'dialog-hbw-210-border-radius',
  modalStyleButton: 'button-pill',
  modalOkStyleButtonColor: BDSMainColor.Primary,
  modalFilterOfficesTextColor: '',
  dashboardCardMarginBottom: 'mb-4',
  dashboardCardRounded: 'xl',
  dashboardCardQuickLinksContainer: 'h-full flex flex-col justify-center ',
  contentBoxContainer: 'mx-4 xs:mx-4 sm:mx-4 md:mx-4 lg:mx-4 ',
  contentBoxSubtitleClass: '',
  contextBoxTitleClass: 'ml-0',
  dashboardCardButtonColor: BDSMainColor.Primary,
  dashboardCardBadgeColor: 'black',
  dashboardQLCardBadgeColor: 'black',
  dashboardWNCardBadgeColor: 'black',
  faqPanelClass: 'flex flex-col md:flex-row p-4 md:p-6',
  faqPanelRoundedSize: 'xl',
  faqPanelShadow: false,
  faqStickyMenuClass: 'w-full md:w-48 mr-12',
  faqStickyMenuButton: 'px-0 py-6 max-w-48 md:w-full',
  faqCategoriesContainerClass: 'max-w-4xl',
  faqStillHaveQuestionsVariant: 'heading-06',
  faqStillHaveQuestionsClass: 'pt-8 md:pt-2 normal-case',
  faqSubmitRequestClass: 'pt-4 md:pt-0',
  faqRequestSupportButtonClass: 'mt-6',
  faqButtonColor: BDSMainColor.Primary,
  drawerDocAddressStyles: 'sm:text-md',
  drawerDocFontWeight: 'font-bold',
  drawerDocDownloadButtonColor: BDSMainColor.Primary,
  badgeActiveColor: BDSMainColor.Primary,
  tableAltRowVariant: 'light',
  tableTextWeight: 'font-bold',
  contactUsHeaderClass: 'Semantics/text/Structural Blue',
  contactUsSuccessTextClass: 'text-left mx-0 lg:text-center lg:m-auto',
  contactUsPanelRounded: 'xl',
  contactUsPanelBorder: '0',
  contactUsFormClass: 'w-fit text-left py-4 lg:text-center p-4 lg:m-auto',
  contactUsFormFaqClass: 'text-black pb-4',
  contactUsFormFaqUrlClass:
    'no-underline text-label text-interactive line-clamp-none horizontal-main-nav-menu-item-link-label inline',
  contactUsThemeTextColor: 'text-primary-400',
  contactUsUploadTitleClass: 'text-black',
  contactUsUploadClass: 'w-full text-center media-upload-format text-primary',
  contactUsSuccessPanelRounded: 'xl',
  contactUsSuccessButtonDivClassName: 'media-upload-format py-6 lg:m-auto button-pill',
  contactUsSuccessButtonWidth: 'auto',
  contactUsSuccessButtonClassName: 'button-pill',
  contactUsSubmitButtonColor: 'primary',
  contactUsSubmitButtonShape: 'pill',
  accountButtonShape: 'pill',
  accountButtonVariant: 'outlined',
  accountButtonColor: 'black',
  accountSubtitleVariant: 'heading-04',
  accountPanelClass: 'p-4 md:p-6 mt-6',
  accountPanelRounded: 'xl',
  accountPanelShadow: false,
  accountInformationLabelMargin: 'mb-6',
  accountInformationContainerClass: 'flex flex-col',
  accountInformationContainerWidth: 'flex flex-col flex-1',
  accountContactInfoButtonContainer: 'flex w-fit self-start ml-1 md:min-w-32',
  accountContactInfoButtonWidth: 'full',
  accountContactInfoButtonClass: 'mt-5',
  accountContactInfoInputContainer: { maxWidth: '680px' },
  accountContactInfoLinkWeight: 'font-bold',
  accountEditLinkClass: 'font-bold pl-4',
  accountContactInfoSaveButtonContainer: 'md:mt-6 md:min-w-32',
  accountContactInfoCaptchaContainer: '',
  accountContactInfoNarContainer: '',
  accountContactInfoNarContaineWidth: { maxWidth: '500px' },
  accountContactInfoInputsContainerWidth: 'w-full',
  accountContactInfoInputsContainerClass: '',
  accountOfficeInfoContainer: 'flex-col md:flex-row',
  accountOfficeInfoContent: 'pl-9',
  accountOfficeInfoButtonWidth: 'full',
  accountOfficeInfoButtonContainer: 'md:min-w-32',
  accountOfficeInfoMBBetweenContent: 'mb-4',
  accountOfficeInfoMTBetweenContent: 'mt-4',
  accountOfficeInfoPanelClass: 'p-4 md:p-6 mt-6',
  accountOfficeTitleContainer: 'mb-4 md:mb-6 flex-col md:flex-row',
  accountOfficeTitleMargin: 'mb-2',
  cardOrderText: 'card--order - grid--agent',
  cardOrderErrorStatusColor: 'order-error-status-text-color',
  btnPillShapedPrimary: 'button-primary button-pill',
  displayNewOrdersPlanMFE: true,
  salesMaterialPanelClass: 'my-6',
  salesMaterialDisplayREProfessionals: false,
  salesMaterialGridClass: 'grid gap-6 md:grid-cols-2 lg:grid-cols-3',
  salesMaterialCardContainerClass: '',
  salesMaterialCardClass: 'h-full flex flex-col shadow-rebrand',
  salesMaterialCardShadow: false,
  salesMaterialCardRounded: 'xl',
  salesMaterialCardMargin: 'mt-6 mx-6',
  salesMaterialCardTitleClass: 'mb-1',
  salesMaterialCardCollapsibleTextClass: '',
  salesMaterialCardLinkUnderlineClass: 'never',
  salesMaterialCardLinkTextExpanded: 'Less',
  salesMaterialCardLinkTextNotExpanded: 'Read more',
  salesMaterialCardSelectClass: 'py-6',
  salesMaterialCardButtonsContainer: 'flex px-6 pb-6 flex-1 flex-col-reverse md:flex-row',
  salesMaterialCardPopoverClass: 'content-end mr-3 w-full',
  salesMaterialCardShareButtonClass: 'mx-0',
  salesMaterialCardShareButtonColor: 'black',
  salesMaterialCardDownloadButtonClass: 'mx-0 mb-5 md:mb-0',
  salesMaterialCardDownloadButtonIcon: false,
  salesMaterialCardDownloadButtonColor: 'primary',
  salesMaterialCardButtonShape: 'pill',
  drawerOrderContainerPadding: '',
  drawerOrderContainerBorder: false,
  drawerOrderCardPadding: 'pr-4',
  drawerOrderCardBorder: ' bg-white rounded-tr-5 rounded-br-5 rounded-bl-5 rounded-tl-5',
  sendDocumentsTrashIconColor: 'interactive',
  sendDocumentsCheckboxContainer: 'flex pl-4 self-center checkbox',
  sendDocumentsHeaderConfirm: 'px-0 md:px-4 text-left',
  sendDocumentsHeaderInvoice: 'px-0 md:px-8 text-left',
  sendDocumentsHeaderRecipients: 'pr-0 md:pr-8',
  sendDocumentsHeaderName: 'pr-0 md:pr-8 w-20 md:w-full',
  sendDocumentsEmail: 'w-20 md:w-full',
  sendDocumentsLabelContainer: 'p-0 w-full',
  sendDocumentsLabel: 'pb-6',
  sendDocumentsLabelVariant: 'heading-03',
  sendDocumentsAddress: 'pb-6',
  sendDocumentsAddressVariant: undefined,
  sendDocumentsTableVariant: 'heavy',
  sendDocumentsContainerButton: 'pt-6',
  sendDocumentsButtonShape: 'pill',
  sendDocumentsAddRecButtonColor: 'black',
  sendDocumentsSaveButtonColor: 'primary',
  sendRenewalItemMT: 'mt-4',
  sendRenewalHeaderWidth: 'w-20 md:w-full',
  sendRenewalCheckboxClass: 'flex pl-4 self-center checkbox',
  sendRenewalCheckboxWidth: 'full',
  sendRenewalTableVariant: 'heavy',
  sendRenewalTableHeaderColor: 'interactive',
  sendRenewalAddButtonWidth: 'full',
  sendRenewalAddButtonColor: 'black',
  sendRenewalTrashIconColor: 'interactive',
  sendRenewalSendButtonColor: 'primary',
  sendDocsNewOrderPanelPadding: 'xl',
  sendDocsNewOrderPanelRounded: 'xl',
  sendDocsNewOrderPanelBorderT: '0',
  sendDocsNewOrderPanelShadow: false,
  addOfficeButtonShape: 'pill',
  addOfficeSearchButtonColor: 'primary',
  addOfficeChooseOfficeButtonColor: 'primary',
  officeSearchResultTitleColor: 'black',
  cantFindOfficeIconColor: 'primary',
  officesContainerClass: '',
  officesSearchIcon: IconTypes.Search,
  officesResultNumberClass: 'mt-6',
  officesResultsContainer: 'mt-4',
  cardOfficePanelRounded: 'xl',
  cardOfficePanelBorderT: '0',
  cardOfficePanelShadow: false,
  cardOfficeNameVariant: 'label',
  cardOfficeLabelVariant: 'caption',
  cardOfficeLabelClass: 'mb-3',
  cardOfficeAddressContainerClass: '',
  cardOfficeContainerLabelClass: 'mb-3',
  cardOfficeWarrantyContainerClass: '',
  cardOfficeWarrantyVariant: 'label',
  drawerWLKInviteOfficeNameClass: 'mt-4',
  drawerWLKInviteOfficeButtonShape: 'pill',
  drawerWLKInviteOfficeButtonColor: 'black',
  drawerWLKInviteOfficeButtonVariant: 'outlined',
  lineItemLabelVariant: 'label',
  lineItemCaptionVariant: 'caption',
  noOfficesFoundShadow: false,
  noOfficesFoundRounded: 'xl',
  noOfficesFoundBorder: '0',
  newOrderPanelBorder: undefined,
  newOrderPanelShadow: false,
  newOrderPanelRounded: 'xl',
  newOrderBuyerPanelBackground: 'accent-50',
  newOrderBuyerPanelRounded: 'xl',
  newOrderBuyerBannerTextColor: 'primary',
  newOrderClosingInfoBackground: 'accent-50',
  newOrderClosingInfoRounded: 'xl',
  newOrderClosingInfoShadow: false,
  formOfficeSearchResults: 'font-bold mb-2',
  formOfficeButtonsContainer: 'mt-5',
  formOfficeCancelButtonClass: 'sm-max:w-full',
  formOfficeSearchButtonClass: 'sm-max:w-full',
  formOfficeResultsContainer: 'mt-5',
  formOfficeResultsPlaceholder:
    'Search this area by company name, address, phone, or Distributor ID...',
  formOfficeSearchIconColor: 'primary',
  formOfficeSearchRadioContainer: 'mt-5',
  formOfficeSearchFieldsContainer: 'mt-2',
  newOrderBannerBackground: 'accent-50',
  newOrderBannerRounded: 'xl',
  newOrderBannerShadow: false,
  newOrderSendDocumentsRounded: 'xl',
  newOrderSendDocumentsBorderT: '0',
  newOrderSendDocumentsShadow: false,
  newOrderSubmitButtonVariant: 'filled',
  newOrderSubmitButtonColor: 'primary',
  newOrderSubmitButtonShape: 'pill',
  newOrderSaveButtonColor: 'black',
  OfficeAutoCompleteButtonColor: 'black',
  autosuggestButtonColor: 'black',
  orderSubmittedPanelClass:
    'flex flex-col mt-6 px-4 sm:px-12 lg:px-32 py-8 sm:py-10 justify-center items-center',
  orderSubmittedPanelShadow: false,
  orderSubmittedPanelBorder: '1',
  orderSubmittedPanelPadding: 'xl',
  orderSubmittedContentClass: 'px-5 md:px-20',
  agentVerificationButtonColor: 'primary',
  agentVerificationLinkColor: '#00A3AD',
  agentVerificationLinkTextDecoration: 'underline',
  agentVerificationLinkFontWeight: 'bold',
  coveredAddressButtonShape: 'pill',
  coveredAddressEditButtonColor: 'primary',
  coveredAddressUseButtonColor: 'black',
  cardPlanPanelRounded: 'xl',
  cardPlanPanelShadow: false,
  cardPlanPanelBorder: '1',
  cardPlanButtonClassName: '',
  inelegibleDwellingSizeUpdateButtonColor: 'primary',
  incompleteOrderFoundModalButtonShape: 'pill',
  missingBuyerPhoneButtonColor: 'primary',
  myQuotesBannerBackgroundColor: 'accent-50',
  myQuotesBannerRounded: 'xl',
  myQuotesBannerShadow: false,
  myQuotesSearchBarIcon: IconTypes.Search,
  myQuotesIdFontWeight: 'font-bold',
  myQuotesFilterButtonShape: 'pill',
  myQuotesSearchBarContainerClass: '',
  myQuotesTableContainerClass: 'sm-max:hidden',
  viewQuoteLeftContainerClass: 'space-y-4',
  viewQuoteRightContainerClass: 'md:pr-2 mt-4 md:mt-0 space-y-4',
  viewQuoteButtonShape: 'pill',
  viewQuoteShareButtonColor: 'black',
  viewQuoteConvertButtonColor: 'primary',
  viewQuoteViewButtonColor: 'black',
  quoteSummaryLabelVariant: 'heading-06',
  quoteSummaryValueVariant: 'body-short',
  quoteSummaryLineItemMarginBottom: 'mb-4',
  quoteSummaryLineItemMarginTop: 'mt-4',
  quoteSummaryCardClass: 'rounded-5 p-6',
  quoteSummaryContainerDisablePadding: true,
  quoteSummaryContainerMargin: '',
  quoteSummaryPlansPricesClass: 'align-center',
  quoteSummaryLineItemContainerClass: 'mb-2',
  quoteSummaryHeaderClass: 'mb-4',
  quoteSummaryResidenceClass: 'text-right',
  quoteSummaryDisplayBreakLine: false,
  quoteSummaryPlanNameVariant: '',
  quoteSummaryDisplaySeparator: true,
  shareQuoteButtonColor: 'primary',
  shareQuoteButtonShape: 'pill',
  cancelQuoteReasonLabelClass: 'mt-6',
  cancelQuoteReasonSelectClass: 'mt-6',
  cancelQuoteOtherReasonClass: 'mt-6',
  cancelQuoteButtonsContainerClass: 'mt-6 flex w-full',
  cancelQuoteButtonClass: 'flex justify-end',
  cancelQuoteCancelButtonColor: 'primary',
  filterQuotesButtonShape: 'pill',
  filterQuotesButtonColor: 'primary',
  newOrderCoverageTableHeaderClass: 'pl-6',
  newOrderPlansContainerLoader: 'p-3',
  wlkAccordianItemPanelClass: 'accordion-item rounded bg-white  border-2 mb-4 ',
  wlkAccordianItemShadow: true,
  wlkPanelRounded: 'xl',
  wlkPanelMobileDisplay: 'flex-column',
  isWlkPropertyAttributesInLowerCase: true,
  wlkButtonClass: 'button-pill',
  wlkMobileSubmissionTextClass: 'mb-4',
  wlkVerificationSubmitButtonColor: 'primary',
  wlkAgreementAcceptButtonColor: 'primary',
  wlkAgreementDeclineButtonColor: 'black',
  hasWlkAttributeBottomMargin: true,
  wlkStickyContainerClass: ' ',
  isWlkDisplayFlex: true,
  plansPricesBaseCoverageContainer: 'pb-4',
  plansPricesBaseCoverageRounded: 'xl',
  plansPricesBaseCoverageBorderT: '0',
  plansPricesCoverageRounded: 'xl',
  plansPricesCoverageBorderT: '0',
  quoteSummaryButtonColor: 'primary',
  plansPricesMFETenant: Tenant.HBW210,
  plansPricesMFETheme: MFETheme.HBW210,
  plansPricesMFEBackgroundColor: 'border border-gray-300',
  plansPricesContentBoxWidth: false,
  drawerOrderButtonColor: 'primary',
  drawerOrderDocumentIconColor: 'black',
  drawerOrderDocumentsClass: 'pb-4',
  drawerOrderDocumentSendButtonVariant: 'filled',
  drawerOrderDocumentSendButtonColor: 'primary',
  drawerOrderEditHistoryTableClass:
    'mt-4 p-4 bg-white rounded-tr-5 rounded-br-5 rounded-bl-5 rounded-tl-5',
  drawerOrderEditHistoryTableIconColor: 'black',
  drawerOrderShowDocDivider: false,
  chatEnabled: true,
  registrationButtonContainerClass: 'flex-col-reverse md:flex-row',
  registrationCancelButtonClass: 'sm-max:mt-4',
  registrationButtonColor: 'primary',
  existingUserContinueButtonColor: 'primary',
  existingUserNoneButtonColor: 'black',
  promoCodeValidateButtonColor: 'primary',
};

export const getCurrentThemeConfig = () => THEME_CONFIG[CurrentTheme()];
